var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-dashboard"},[_c('div',{staticClass:"m-content"},[_c('div',{staticClass:"m-grid__item m-grid__item--fluid m-wrapper"})])])}]

export { render, staticRenderFns }